// Module
var code = `<s-multi-select-items class="d-block multi-select-modal" items="items" on-item-toggle="onItemToggle()"/> `;
// Exports
var _module_exports =code;;
var path = '/common/directives/multiSelect/multiSelectItems/multiSelectItemsModal/multiSelect.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;